module.exports = __webpack_public_path__ + "static/img/18_pro.7297823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/18_pro.jpg
// module id = w1Jp
// module chunks = 0